import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { H2 } from 'foundations-components/transitional/components/H2';
import { Children } from 'react';
import { CardHeader, CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ExpandingFAQ = ({
  Content,
  DefaultExpanded = false,
  Title,
  onExpandedChange
}) => /*#__PURE__*/_jsxs(CardWrapper, {
  compact: true,
  defaultExpanded: DefaultExpanded,
  expandable: true,
  borderWidth: "100",
  borderRadius: "300",
  onExpandedChange: onExpandedChange,
  marginBlockEnd: "0",
  children: [/*#__PURE__*/_jsx(CardHeader, {
    title: Title,
    titleSize: "small"
  }), /*#__PURE__*/_jsx(CardSection, {
    children: Content
  })]
});
export const FrequentlyAskedQuestionsContainer = ({
  children
}) => {
  const childrenArray = Children.toArray(children);
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "100%",
    children: [/*#__PURE__*/_jsx(H2, {
      marginBlockEnd: "500",
      "aria-level": 2,
      typography: "heading-400",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.title"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      gap: "400",
      flexDirection: "column",
      children: childrenArray
    })]
  });
};